import React__default, { useState, useRef } from 'react';
import { Label } from 'reactstrap';
import { Controller } from '../../../../../../node_modules/.pnpm/react-hook-form@7.22.0_react@19.0.0/node_modules/react-hook-form/dist/index.esm.mjs.js';
import { FontAwesomeIcon } from '../../../../../../node_modules/.pnpm/@fortawesome_react-fontawesome@0.2.2_@fortawesome_fontawesome-svg-core@6.7.2_react@19.0.0/node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faTimes, faExclamationTriangle } from '../../../../../../node_modules/.pnpm/@fortawesome_free-solid-svg-icons@6.7.2/node_modules/@fortawesome/free-solid-svg-icons/index.mjs.js';
import { useFormContext } from '../Form.js';
import classNames from '../../../../../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js';
import FormInputSearchDropdownCore from './FormInputSearchDropdownCore.js';
import { sanitize } from '@ibe/services';
import useClickAway from '../../../../../../node_modules/.pnpm/react-use@17.6.0_react-dom@19.0.0_react@19.0.0/node_modules/react-use/esm/useClickAway.js';

const FormInputSearchDropdown = (props) => {
    const { name, baseName, label, boldLabel, errorsProp, showErrors, showErrorIcon } = props;
    const { register, errors, control, setValue, exposeSeparateFieldValue } = useFormContext();
    const [collapseOpen, setCollapseOpen] = useState(false);
    const containerRef = useRef(null);
    useClickAway(containerRef, () => {
        setCollapseOpen(false);
    });
    if (!register)
        return null;
    const formErrors = errorsProp || errors;
    return (React__default.createElement("div", { ref: containerRef, className: classNames('form-input', {
            'input--error': formErrors && showErrors && formErrors[baseName || name]
        }) },
        !!label && (React__default.createElement(Label, { className: `${formErrors && showErrors && formErrors[baseName || name] ? 'form__error__top' : ''}${boldLabel ? ' font-weight-bold' : ''}`, dangerouslySetInnerHTML: { __html: sanitize(label, true) } })),
        React__default.createElement(Controller, { name: name, control: control, render: ({ field }) => (React__default.createElement(FormInputSearchDropdownCore, { ...props, field: field, collapseOpen: collapseOpen, setCollapseOpen: setCollapseOpen, exposeSeparateFieldValue: exposeSeparateFieldValue, setValue: setValue })) }),
        React__default.createElement(FontAwesomeIcon, { className: "form-input__clear", icon: faTimes, onClick: () => {
                if (!!setValue) {
                    setValue(name, '');
                }
            } }),
        formErrors && showErrors
            ? formErrors[baseName || name] && (React__default.createElement("div", { className: "form__error" }, formErrors[baseName || name].message))
            : null,
        showErrorIcon && formErrors && showErrors && formErrors[baseName || name] && (React__default.createElement(FontAwesomeIcon, { icon: faExclamationTriangle }))));
};

export { FormInputSearchDropdown as default };
//# sourceMappingURL=FormInputSearchDropdown.js.map
